import { FC, useEffect, useState } from 'react';
import DefaultLayout from 'components/Rsuite/Layout/DefaultLayout';
import { OutboundReport } from 'containers/OutboundReportPage/OutboundReport';
import { getOutboundReport } from 'ws/OutboundReportWebService';
import { useCallAPI } from 'hooks/useCallAPI';
import moment from 'moment';

export const OutboundReportPage: FC = () => {
  const { callAPIs } = useCallAPI();
  const [reportData, setReportData] = useState([]);
  const [reportFilter, setReportFilter] = useState({
    rtbCampaignId: '',
    sellerId: '',
    brandName: '',
    startDate: moment().startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  });

  const handleGetOutboundReport = async () => {
    return await callAPIs([() => getOutboundReport(reportFilter)], (report) => {
      setReportData(report);
    });
  };

  const handleChangeFilter = (filter) => {
    setReportFilter(filter);
  };

  const handleResetFilter = async () => {
    setReportFilter({
      rtbCampaignId: '',
      sellerId: '',
      brandName: '',
      startDate: moment().startOf('day').toDate(),
      endDate: moment().endOf('day').toDate(),
    });
    return await callAPIs(
      [
        () =>
          getOutboundReport({
            rtbCampaignId: '',
            sellerId: '',
            brandName: '',
            startDate: moment().startOf('day').toDate(),
            endDate: moment().endOf('day').toDate(),
          }),
      ],
      (report) => {
        setReportData(report);
      },
    );
  };

  const handleSubmit = () => {
    handleGetOutboundReport();
  };

  useEffect(() => {
    handleGetOutboundReport();
  }, []);

  return (
    <DefaultLayout title={'站外監控報表'}>
      <div className='p-6'>
        <OutboundReport
          reportData={reportData}
          reportFilter={reportFilter}
          onChange={handleChangeFilter}
          onSubmit={handleSubmit}
          onReset={handleResetFilter}
        />
      </div>
    </DefaultLayout>
  );
};
